import React from 'react'

export const FirstHeading = (props) => {
  return (
    <>
        <h1 className='text-large color-dark'>{props.heading}</h1>
    </>
  )
}
